import type { SelectOption } from '../types';

interface OptionContentProps {
  option: SelectOption;
}

export const OptionContent = ({ option }: OptionContentProps) => {
  if (option.isCustom && option.customContent) {
    return <>{option.customContent}</>;
  }

  return (
    <div className="flex items-center w-full gap-3 ml-2">
      <span className="text-white font-medium">{option.label}</span>
      {option.avatar && (
        <img
          src={option.avatar}
          alt={option.label}
          className="w-6 h-6 rounded-full flex-shrink-0 object-cover"
        />
      )}
      {option.additionalInfo && <div className="flex-shrink-0">{option.additionalInfo}</div>}
    </div>
  );
};
